import type { UserLocalStorage } from '../../types/localStorage';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, useMemo } from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import {
  DndProvider,
  MouseTransition,
  TouchTransition,
} from 'react-dnd-multi-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { createPortal } from 'react-dom';
import useLocalStorageState from 'use-local-storage-state';

import FlotiqPlugins from '../../lib/flotiq-plugins/flotiqPluginsRegistry';

import Toast from '../../components/Toast/Toast';

import AppRouter from '../../router/AppRouter';

const App = () => {
  const [user] = useLocalStorageState<UserLocalStorage>('cms.user');
  const [debuggerEnabled] = useLocalStorageState<boolean>('cms.debugger');

  useEffect(() => {
    if (!user) {
      if (FlotiqPlugins.getLoadedPluginsIds().length) window.location.reload();
    }
  }, [user]);

  const HTML5toTouch = useMemo(
    () => ({
      backends: [
        {
          id: 'html5',
          backend: HTML5Backend,
          transition: MouseTransition,
        },
        {
          id: 'touch',
          backend: TouchBackend,
          options: { enableMouseEvents: true },
          preview: true,
          transition: TouchTransition,
        },
      ],
    }),
    [],
  );

  const portalWithToast = createPortal(<Toast testId="toast" />, document.body);

  return (
    <>
      {portalWithToast}
      <DndProvider options={HTML5toTouch}>
        <AppRouter />
      </DndProvider>
      {debuggerEnabled === true && <ReactQueryDevtools />}
    </>
  );
};

export default App;
